import { FiltersContext, DownloadPageLayout } from '@bpm-web-app/components';
import { Genres, GenresDetail } from '@bpm-web-app/components/pages';
import { useHubSwitch } from '@bpm-web-app/utils';
import { useRouter } from 'next/router';
import { useContext, useEffect } from 'react';

export default function GenresPage({ title }: { title: string }) {
    const { query } = useRouter();
    const { category, genre } = query;
    const { hub } = useHubSwitch();
    const { resetFilters, updateFiltersFromQuery } = useContext(FiltersContext);

    useEffect(() => {
        resetFilters();
    }, [category, resetFilters]);

    useEffect(() => {
        updateFiltersFromQuery(query);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [genre, category]);

    return (
        <DownloadPageLayout title={title}>
            {!category && !genre && <Genres />}
            {(category || genre) && <GenresDetail key={hub} category={category} genre={genre} />}
        </DownloadPageLayout>
    );
}

export async function getStaticProps() {
    return {
        props: {
            title: 'Genres',
        },
    };
}
